// Registry of the client-facing wizards that share the checkup shell, and the
// route -> wizard lookup that lets one shell drive both (#656).
//
// Dispatch is by BASE PATH, not by step id: /checkup and /renewal both own a
// `sign` and a `done` step, so the trailing slug alone is ambiguous and only
// means something once the wizard is known.
import { CHECKUP_WIZARD } from '~/data/checkup-config'
import { RENEWAL_WIZARD } from '~/data/renewal-config'

export const WIZARDS = [CHECKUP_WIZARD, RENEWAL_WIZARD]

// Falls back to the checkup wizard rather than null so callers never have to
// null-guard: the shell's components are mounted in unit tests with partial or
// absent $route mocks (test/checkup/*.spec.js), and every one of those is a
// checkup test. A real unmatched route can't reach the shell at all — Nuxt has
// no page to render for it.
export function wizardForRoute (route) {
    const path = route?.path || ''
    return WIZARDS.find(w => path === w.basePath || path.startsWith(`${w.basePath}/`)) || CHECKUP_WIZARD
}
